import { ChatBase } from "@Base/Engagement/Chat/ChatBase";
import { IQuiqOptions } from "@Base/Engagement/Chat/IQuiqOptions";
import { TextResource } from "@Utilities/TextResource";

export class Chat extends ChatBase
{
	constructor()
	{
		super();
	}

	public override GetSiteOptions(): IQuiqOptions
	{
		const primary = "#02a7d9";
		const primaryBorder = `1px solid ${primary}`;
		const secondary = "#900";

		/*
		* These options are provided to the Quiq chat object on initialization.
		* NOTE: Chat options can be overridden at the site level for various look-and-feel details.
		*
		* See the full list of available options that can be configured for Quiq chat:
		* https://developers.goquiq.com/docs/webchat/#/reference/types
		*/
		const siteOptions: IQuiqOptions = {
			contactPoint: "funcom",
			colors: {
				primary: primary,
				agentMessageDropdownButtonBackground: primary,
				agentMessageLinkText: primary
			},
			styles: {
				HeaderMenu: {
					backgroundColor: primary
				},
				WelcomeFormSubmitButton: {
					borderColor: secondary,
					backgroundColor: secondary
				},
				AgentRichMessage: {
					button: {
						borderColor: primary,
						color: primary
					}
				},
				InlineActionButton: {
					border: primaryBorder,
					color: primary
				},
				MessageFormSend: {
					backgroundColor: primary
				},
				OptionsMenuLineItem: {
					color: primary
				},
				OptionsMenuLineItemIcon: {
					color: primary
				}
			},
			messages: {
				headerText: TextResource.GetTextByCulture("Feature_Chat_AskAnythingFunny")
			}
		};

		if (TextResource.GetLanguage() === "es")
		{
			siteOptions.language = "es";
		}

		return siteOptions;
	};
}